// Action types for Override reducer
export const OVERRIDE_ACTION_TYPES = {
  SET_FIELD: "SET_FIELD",
  SET_ERROR: "SET_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
  RESET_FORM: "RESET_FORM",
  SET_RECIPIENTS: "SET_RECIPIENTS",
  SET_GRADE_DIVISION_MAP: "SET_GRADE_DIVISION_MAP",
  SET_STUDENT_IDS: "SET_STUDENT_IDS",
};
